import { render, staticRenderFns } from "./PositionsListItems.vue?vue&type=template&id=1db2395b&scoped=true"
import script from "./PositionsListItems.js?vue&type=script&lang=js&external"
export * from "./PositionsListItems.js?vue&type=script&lang=js&external"
import style0 from "./PositionsListItems.scss?vue&type=style&index=0&id=1db2395b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db2395b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotPositionCard: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/PositionCard/PositionCard.vue').default,HotNoResults: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/NoResults/NoResults.vue').default})
